import { render, staticRenderFns } from "./mainTemplate.vue?vue&type=template&id=305a5667"
import script from "./mainTemplate.vue?vue&type=script&lang=js"
export * from "./mainTemplate.vue?vue&type=script&lang=js"
import style0 from "./mainTemplate.vue?vue&type=style&index=0&id=305a5667&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports